module.exports = __webpack_public_path__ + "img/703.1f9f95b5.jpg";